// extracted by mini-css-extract-plugin
export default {"spanBlock":"SuperEditableSpan_spanBlock__bSp2T","span":"SuperEditableSpan_span__luGhL","input":"SuperEditableSpan_input__eJNkS","pen":"SuperEditableSpan_pen__K6V0L"};